import React from 'react';
import { Card, CardBody, CardTitle, Input, Label, FormGroup } from 'reactstrap';
import HelpIcon from '../search-components/HelpIcon';
import ResetFormComponentDefaults from './ResetFormComponent';

const help = {
  arbitral: {
    name: 'Arbitraliosiomis laikomos tokios kolokacijos, kurias sudarant teoriškai galima rinktis kelis panašios reikšmės žodžius, bet dėl nusistovėjusių kalbos dėsningumų vartojamas kuris nors vienas, pvz., <i>teikti</i>, bet ne <i>duoti apdovanojimą</i>; <i>stipri</i>, bet ne <i>galinga sveikata</i>.',
    value: 'arbitral',
  },
};

class AdvancedCompoundInput extends React.Component {

  render() {
    return (
      <Card className="p-2 m-2 bg-light">
        <CardBody>
          <CardTitle>Junginys</CardTitle>
        </CardBody>

        <FormGroup>
          <Label for="srSelect">Sintaksinis ryšys (dvižodžiams)</Label>
          <Input type="select" name="sr" id="srSelect" value={this.props.sr}
                 onChange={this.props.onInputChange} disabled={this.props.srDisabled}
          >
            {this.props.srSelect.map((kw) =>
              <option value={kw.value} key={kw.value}>{kw.name}</option>
            )}
          </Input>
        </FormGroup>

        <FormGroup>
          <Label for="wcSelect">Žodžių skaičius</Label>
          <Input type="select" name="wc" id="wcSelect" value={this.props.wc} onChange={this.props.onInputChange}>
            {this.props.wcSelect.map((kw) =>
              <option
                disabled={(kw.value === '3' && this.props.wc3Disabled) || (kw.value === '2' && this.props.wc2Disabled)}
                value={kw.value} key={kw.value}>{kw.name}
              </option>
            )}
          </Input>
        </FormGroup>

        <FormGroup>
          <Label for="freqSelect">Dažnis</Label>
          <Input type="select" name="freq" id="freqSelect" value={this.props.freq}
                 onChange={this.props.onInputChange}>
            {this.props.freqSelect.map((kw) =>
              <option value={kw.value} key={kw.value}>{kw.name}</option>
            )}
          </Input>
        </FormGroup>

        <FormGroup>
            <Label for="arbitralSelect">
                Arbitralusis <HelpIcon text={help.arbitral.name} value={help.arbitral.value}/>
            </Label>
            <Input type="select" name="arbitral" id="arbitralSelect" value={this.props.arbitral}
                   onChange={this.props.onInputChange}>
                {this.props.arbitralSelect.map((kw) =>
                    <option value={kw.value} key={kw.value}>{kw.name}</option>
                )}
            </Input>
        </FormGroup>

        <ResetFormComponentDefaults resetDefaults={this.props.resetDefaults} value={'coll'}/>
      </Card>
    );
  }
}

export default AdvancedCompoundInput;

